import React from "react";
import * as styles from "./styles.module.scss";
import SiteGutter from "../SiteGutter";
import SocialMediaList from "./SocialMediaList";
import Link from "../Link";
import { useStaticQuery, graphql } from "gatsby";
import cx from "classname";
import normalizeContentfulModel from "../../../normalizeContentfulModel";
import RichText from "../RichText";

function SiteFooterV2() {
  const data = useStaticQuery(graphql`
    query FooterV2 {
      allContentfulGlobal(filter: { key: { eq: "Footer" } }) {
        nodes {
          slices {
            ... on ContentfulSingleLineText {
              key
              value
            }
            ... on ContentfulMultiLineText {
              key
              content: value {
                raw
              }
            }
            ... on ContentfulGroup {
              key
              slices {
                ... on ContentfulSingleLineText {
                  key
                  value
                }
                ... on ContentfulLink {
                  key
                  label
                  url
                }
              }
            }
          }
        }
      }
    }
  `);
  const { FooterLinks, copyright, SocialMediaLinks, copyrightBody } =
    normalizeContentfulModel(data.allContentfulGlobal.nodes[0]).slices;

  return (
    <div className={styles.container}>
      <SiteGutter>
        <footer className={styles.footer}>
          <div className={styles.right}>
            <div>
              <ul className={styles.navigation}>
                {Object.values(FooterLinks).map(({ url, label }, i) => (
                  <li key={i}>
                    <Link
                      url={url}
                      label={label}
                      target="_blank"
                      rel="noopener"
                    />
                  </li>
                ))}
              </ul>
              <div className={styles.social}>
                <SocialMediaList size="large" links={SocialMediaLinks} />
              </div>
            </div>
          </div>
          <div className={styles.left}>
            <div className={cx(styles.copyright, styles.desktop)}>
              {copyrightBody ? <RichText value={copyrightBody} /> : copyright}
            </div>
          </div>
        </footer>
        <div className={cx(styles.copyright, styles.mobile)}>
          {copyrightBody ? <RichText value={copyrightBody} /> : copyright}
        </div>
      </SiteGutter>
    </div>
  );
}

export default SiteFooterV2;
